import styled from 'styled-components'
import YouTube from 'react-youtube'
import {Button} from '@components/lib'

export const YouTubeIframe = styled(YouTube)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const IframeWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  width: 100%;
`

export const ButtonClose = styled(Button)`
  width: auto;
  margin: 15px auto 0;
  padding: 0;
`
